import dayjs from 'dayjs'
import { useState } from 'react'
import Modal from 'react-modal'
import NumberFormat from 'react-number-format'
import { useSelector } from 'react-redux'
import { WatDatePicker } from '../../component/datePicker'
import { LoadingOverlay } from '../../component/loadingOverlay'
import { RootReducers } from '../../redux/reducers'

interface SmsModalProps {
  isOpenModal: boolean
  handleOkButton: () => Promise<void>
  handleCancelbutton: () => void
  handelModalDataChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleWatDatePickerChange: (christDate: any, buddhistDate: any) => void
  policyInfo: any
}

export const SMSModal: React.VFC<SmsModalProps> = ({
  handleOkButton,
  handleCancelbutton,
  isOpenModal,
  handelModalDataChange,
  handleWatDatePickerChange,
  policyInfo
}) => {
  const [processing, setProcessing] = useState(false)
  const [errors, setErrors] = useState({ date: '', sms: '' })
  const isBranchStaff = useSelector(
    (state: RootReducers) => state.loginReducer.account?.agentInfo.isBranchStaff
  )

  const checkDisableSms = () => {
    if (isBranchStaff) {
      return false
    } else {
      return policyInfo.autoDisplay
    }
  }

  const validateForm = () => {
    let isNotError = true
    let msg = ''
    debugger
    const error: any = {}
    if (!policyInfo.customerDOB || (policyInfo.customerDOB as string).length == 0) {
      msg = 'กรุณาระบุ วัน/เดือน/ปี เกิดผู้เอาประกันภัย'
      error.date = msg
      setErrors(error)
      isNotError = false
    }
    if ((policyInfo.customerPhone as string).length == 0) {
      msg = 'กรุณาระบุ เบอร์โทรศัพท์มือถือของผู้เอาประกันภัย'
      error.sms = msg
      setErrors(error)
      isNotError = false
    }
    const phoneNumberPattern = /^(0\d{9})$/
    if (policyInfo.autoDisplay && !isBranchStaff) {
      if (!phoneNumberPattern.test(policyInfo.saveCustomerPhone)) {
        msg = 'กรุณาระบุ เบอร์โทรศัพท์มือถือของผู้เอาประกันภัยให้ถูกต้อง'
        error.sms = msg
        setErrors(error)
        isNotError = false
      }
    } else if (!phoneNumberPattern.test(policyInfo.customerPhone)) {
      msg = 'กรุณาระบุ เบอร์โทรศัพท์มือถือของผู้เอาประกันภัยให้ถูกต้อง'
      error.sms = msg
      setErrors(error)
      isNotError = false
    }

    if (isNotError) {
      setProcessing(true)
      setErrors({ date: '', sms: '' })
      handleOkButton().finally(() => {
        setProcessing(false)
      })
    }
  }

  const closeModal = () => {
    setErrors({ date: '', sms: '' })
    handleCancelbutton()
  }

  const displayMobileNoFormat = () => {
    if (policyInfo.autoDisplay && policyInfo.isServiceAgent) return '0#########'
    if (policyInfo.autoDisplay) return '******####'

    return '0#########'
  }

  return (
    <div>
      <Modal
        isOpen={isOpenModal}
        className="modal-send-message"
        ariaHideApp={false}
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(24, 48, 40, 0.9)'
          }
        }}
      >
        {processing && <LoadingOverlay />}
        <form autoComplete="off">
          <div className="modal-email-content">
            <div>
              <div className="modal-email-header-text">ยืนยันการส่ง SMS</div>
              <div className="modal-email-detail">
                <div>วันเดือนปีเกิดผู้เอาประกันภัย</div>
                <div>
                  <WatDatePicker
                    data-testid="dateInput"
                    // Can be replace with string or dayjs object (e.g. "2020-12-31" or `dayjs()`)
                    onChange={(christDate: any, buddhistDate: any) => {
                      setErrors({ ...errors, date: '' })
                      handleWatDatePickerChange(christDate, buddhistDate)
                    }}
                    dateFormat={'yyyy-MM-dd'} // for set data purpose [using date-fns format](https://date-fns.org/v2.12.0/docs/format)
                    displayFormat={'DD/MM/YYYY'} // for display purpose (using dayjs format)[https://day.js.org/docs/en/display/format]
                    // inputStyle={{ color: 'red' }} // styles for input
                    clearable={false} // true | false
                    minDate={dayjs().add(-100, 'year')} // supported date as string
                    maxDate={dayjs()} // also supported dayjs or moment
                    disabled={policyInfo.autoDisplay}
                    readOnly={false} // true | false
                    yearBoundary={99} // number of boundary ±X Year
                    inputStyle={errors.date ? { borderColor: '#b30909' } : null}
                    value={policyInfo.customerDOB}
                  />
                </div>
                {errors.date && <span className="error-text-validate">{errors.date}</span>}

                <div>เบอร์โทรศัพท์มือถือของผู้เอาประกันภัยหรือผู้ชำระเบี้ย</div>
                <div>
                  <NumberFormat
                    data-testid="phoneInput"
                    disabled={checkDisableSms()}
                    type="tel"
                    format={displayMobileNoFormat()}
                    id="sms"
                    name="customerPhone"
                    value={policyInfo.customerPhone}
                    onChange={handelModalDataChange}
                  ></NumberFormat>
                  {errors.sms && <span className="error-text-validate">{errors.sms}</span>}
                </div>
              </div>
            </div>

            <div className="modal-email-group-button">
              <button type="button" className="cancel-email-button" onClick={() => closeModal()}>
                ย้อนกลับ
              </button>
              <button type="button" className="confirm-email-button" onClick={() => validateForm()}>
                ส่ง SMS
              </button>
            </div>
          </div>
        </form>
      </Modal>
    </div>
  )
}
